import { InputAdornment } from "@mui/material";
import { getIn } from "formik";
import { HTMLInputTypeAttribute, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ToggleableTextfield from "../ToggleableTextfield";
import { EasyFieldProps } from "./EasyForm";
interface EasyTextfieldProps {
    editMode: boolean
    fieldName: string
    key: string
    endAdornment?: string
    displayText?: string
    showLabel: boolean
    type: HTMLInputTypeAttribute
    render?: (content: unknown) => JSX.Element
    conditionFieldName?: string;
    conditionShouldBeDisabledFunc: (conditionFieldNameValue: any) => boolean
    multiline: boolean;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
    overrideValue?: string
}

export default function EasyTextfied(props: EasyTextfieldProps & EasyFieldProps): JSX.Element {
    const fieldValue = getIn(props.values, props.fieldName)
    const [localValue, setLocalValue] = useState(fieldValue);
    useEffect(() => {
        if (props.overrideValue) {
            updateFieldValue(props.overrideValue);
            setLocalValue(props.overrideValue);
        }
    }, [props.overrideValue])


    const { t } = useTranslation();
    let disabled = false;
    if (props.conditionFieldName) {
        const disabledConditionFieldValue = getIn(props.values, props.conditionFieldName)
        disabled = props.conditionShouldBeDisabledFunc(disabledConditionFieldValue)
    }
    if (disabled && fieldValue !== "" && fieldValue !== null) {
        updateFieldValue("");
    }

    function handleLocalChange(inputValue: string): void {
        if (inputValue != localValue) {
            setLocalValue(inputValue);
        }
    }

    function updateFieldValue(value: string | undefined): void {
        // if a number field is sent to the api as "", the api interprets it as missing from the request and does not update
        if(props.type === "number" && (value === undefined || value === "")) {
            props.setFieldValue(props.fieldName, null);
        } else {
            props.setFieldValue(props.fieldName, value);
        }
    }

    return (
        <>
            <ToggleableTextfield
                editMode={props.editMode}
                InputProps={{
                    endAdornment: props.endAdornment ? <InputAdornment position="end">{props.endAdornment}</InputAdornment> : undefined,
                }}
                disabled={disabled}
                fullWidth
                minWidth={props.minWidth}
                key={props.key}
                label={props.showLabel ? t(props.displayText ?? "") + "" : undefined}
                type={props.type}
                id={props.fieldName}
                name={props.fieldName}
                render={props.render}
                value={disabled ? "" : localValue}
                onChange={(e) => handleLocalChange(e.target.value)}
                onBlur={() => updateFieldValue(localValue)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        updateFieldValue(localValue);
                    }
                }}
                multiline={props.multiline}
                error={disabled ? false : (props.submitCount > 0 || getIn(props.touched, props.fieldName)) && Boolean(getIn(props.errors, props.fieldName))}
                helperText={disabled ? undefined : (props.submitCount > 0 || getIn(props.touched, props.fieldName)) && getIn(props.errors, props.fieldName)}
            />
        </>

    )
}